var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { fullscreen: "", persistent: "" },
      model: {
        value: _vm.showWhiteBoardModal,
        callback: function ($$v) {
          _vm.showWhiteBoardModal = $$v
        },
        expression: "showWhiteBoardModal",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "whiteboard-modal" },
        [
          _c(
            "v-card-title",
            {
              staticClass: "headline font-weight-bold text-h6",
              attrs: { "primary-title": "" },
            },
            [
              _c("p", { staticClass: "headlineText" }, [
                _vm._v(_vm._s(_vm.$t("whiteBoard"))),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", color: "body" },
                  on: { click: _vm.close },
                },
                [_c("icon", { attrs: { icon: "x", width: "28" } })],
                1
              ),
            ],
            1
          ),
          _c("v-card-text", { staticClass: "content" }, [_c("WhiteBoard")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }